<!-- 横向菜单，只有二级 -->
<template>
    <div class="horizontal_menu_lyout">
        <template v-for="(item,index) in newMenuList" >
        <a v-if="$utils.isNoNullAll(item.Url)" :href="$constant.allHttpUrl.baseAddressUrl+item.Url" :key="temTime+'a_'+index" target="_blank" class="horizontal_menu_lyout_item horizontal_menu_lyout_item2" :class="{item_active:itemActiveFun(index,item)}" >{{ item.name }}</a>
        <router-link v-else-if="$utils.isNoNullAll(item.routeUrl || item.path)" :to="item.routeUrl || item.path" :key="temTime+'a_'+index" class="horizontal_menu_lyout_item horizontal_menu_lyout_item2" :class="{item_active:itemActiveFun(index,item)}" >{{ item.name }}</router-link>
        <div v-else :key="temTime+'menu_'+index" class="horizontal_menu_lyout_item" :class="{item_active:itemActiveFun(index,item)}" >
            <el-popover
                v-if="!$utils.isArrayEmpty(item.children)"
                placement="bottom"
                trigger="hover"
                :visible-arrow="false"
                v-model="item['_value'+temTime]"
                popper-class="background_12171D horizontal_menu_lyout_child_content_popover"
                >
                <div class="horizontal_menu_lyout_child_content">
                    <template v-for="(item2,index2) in item.children">
                        <a v-if="$utils.isNoNullAll(item2.Url)" :href="$constant.allHttpUrl.baseAddressUrl+item2.Url" target="_blank" :key="'a_menu_'+index+'_'+index2" class="menu_lyout_child_content_item cursorPointer" :class="{child_item_active:childItemActive(index,index2,item2)}">
                            <!-- sq 编辑，增加路由模块内配置title和icon属性 -->
                            <!--  <img :src="item2.icon || item2.meta && item2.meta.icon" alt=""> -->
                            <i class="iconfont" :class="item2.icon || item2.meta && item2.meta.icon"></i>
                            <!-- <i :class="'iconfont '+item2.icon"></i> -->
                            <span>{{ item2.name }}</span>
                        </a>
                        <router-link v-else-if="$utils.isNoNullAll(item2.routeUrl || item2.path)" :to="item2.routeUrl || item2.path" :key="'router_menu_'+index+'_'+index2" class="menu_lyout_child_content_item cursorPointer" :class="{child_item_active:childItemActive(index,index2,item2)}">
                            <!-- sq 编辑，增加路由模块内配置title和icon属性 -->
                            <!--  <img :src="item2.icon || item2.meta && item2.meta.icon" alt=""> -->
                            <i class="iconfont" :class="item2.icon || item2.meta && item2.meta.icon"></i>
                            <!-- <i :class="'iconfont '+item2.icon"></i> -->
                            <span>{{ item2.name }}</span>
                        </router-link>

                        <div v-else :key="'div_menu_'+index+'_'+index2" class="menu_lyout_child_content_item cursorPointer" :class="{child_item_active:childItemActive(index,index2,item2)}">
                            <!-- sq 编辑，增加路由模块内配置title和icon属性 -->
                            <!--  <img :src="item2.icon || item2.meta && item2.meta.icon" alt=""> -->
                            <i class="iconfont" :class="item2.icon || item2.meta && item2.meta.icon"></i>
                            <!-- <i :class="'iconfont '+item2.icon"></i> -->
                            <span>{{ item2.name }}</span>
                        </div>
                    </template>
                </div>
                <div class="horizontal_menu_lyout_child_content_b"></div>
                <div class="horizontal_menu_lyout_item_text" slot="reference">{{ item.name }}</div>
            </el-popover>
            <span class="horizontal_menu_lyout_item_text" v-else>{{ item.name }}</span>
        </div>
        </template>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props:{
            menuList:{
                type:Array,
                default:()=>{
                    return [];
                }
            },
            routePath:{
                type:String,
                default:"",
            }
        },
        computed: {
        },
        data() {
            return {
                temTime:"",
                activeIndex:undefined,//父
                childActiveIndex:undefined,//子
                newMenuList:[],//新菜单列表
            };
        },
        watch:{
            menuList:{//菜单
                handler(newV){
                    this.newMenuList=this.initData(newV).result||[];
                },
                immediate: true,//true刷新也会触发
            },
            $route:{//菜单
                handler(newV){
                    console.log();
                },
                immediate: true,//true刷新也会触发
            },
        },
        created(){
            this.temTime=new Date().getTime();
        },
        methods: {
            // initData_(element){
            //     let result=[];
            //     if(!this.$utils.isArrayEmpty(element.children)){
            //         let list=element.children;
            //         for (let index = 0; index < list.length; index++) {
            //             let element = {...list[index]};
            //             element.children=this.initData_(element);
            //             result.push(element);
            //         }
            //     }
            //     return result;
            // },

            initData(list){
                let timte=new Date().getTime();
                let result=[];//
                let paths=[];//路由数组
                if(!this.$utils.isArrayEmpty(list)){
                    for (let index = 0; index < list.length; index++) {
                        let element = {...list[index]};
                        element.paths=[];
                        //路由数组
                        if(this.$utils.isNoNullAll(element.routeUrl)){
                            element.paths.push(element.routeUrl);
                            paths.push(element.routeUrl);
                        }
                        //子
                        let tem=this.initData(element.children);
                        element.children=tem.result||[];
                        element.paths=[...element.paths,...(tem.paths||[])];

                        result.push(element);
                    }
                }
                return {result:result,paths:paths};
            },

            itemActiveFun(index,item){//激活
                let result=false;
                if(item['_value'+this.temTime]||(!this.$utils.isArrayEmpty(item.paths)&&item.paths.indexOf(this.$route.path)!=-1)){
                    result=true;
                }
                return result;
            },
            childItemActive(index,index2,item){//激活
                let result=false;
                if(!this.$utils.isArrayEmpty(item.paths)&&item.paths.indexOf(this.$route.path)!=-1){
                    result=true;
                }
                return result;
            },

            clickMenu(item){//点击菜单
                this.$emit("clickMenu",item);
            },

            clickPMenu(index,item){//点击父菜单
                this.clickMenu(item);
            },
            
            clickChildMenu(pindex,childIndex,item){//点击子菜单
                // if (item.Url) {
                //     let origin = window.location.origin.indexOf('localhost') == -1 && window.location.origin.indexOf('192.168') == -1 ? window.location.origin : 'http://www.valuetek.com.cn'
                //     window.open(origin+item.Url);
                //     return "";
                // }

                // this.clickMenu(item);
                if(this.$utils.isNoNullAll(item.routeUrl || item.path)){
                    return item.routeUrl || item.path;
                }
                return "";
            },
        }
    }
</script>

<style lang="less" scoped>
@import url("./custom-horizontal-menu.less");
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
</style>
